import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { fluidizeFixedWidths } from '@/util/emailHtml'


export default /*#__PURE__*/_defineComponent({
  __name: 'HtmlComponent',
  props: {
    componentData: null,
    selected: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as {
  componentData: {
    html?: string
    hoistedStyles?: string
    styles?: Record<string, string>
  }
  selected?: boolean
}





const frame = ref<HTMLIFrameElement | null>(null)
const frameHeight = ref(40)

const hasHtml = computed(() => Boolean((props.componentData.html || '').trim()))

const srcdoc = computed(() => {
  const styles = props.componentData.hoistedStyles || ''
  // Same rewrite the renderer applies on send, so the preview matches the email.
  const html = fluidizeFixedWidths(props.componentData.html || '')
  return `<!doctype html><html><head><style>body{margin:0;padding:0}</style><style>${styles}</style></head><body>${html}</body></html>`
})

const paddingStyles = computed(() => {
  const s = props.componentData.styles || {}
  return {
    padding: `${s.paddingTop || '0'}px ${s.paddingRight || '0'}px ${s.paddingBottom || '0'}px ${s.paddingLeft || '0'}px`,
  }
})

function measure() {
  const el = frame.value
  if (!el || !el.contentDocument || !el.contentDocument.body) return
  frameHeight.value = Math.max(40, el.contentDocument.body.scrollHeight)
}

// srcdoc changes re-trigger load, but some browsers skip the event when only
// the string identity changes; measure on next frame as a fallback.
watch(srcdoc, () => {
  requestAnimationFrame(() => measure())
})

return { __sfc: true,props, frame, frameHeight, hasHtml, srcdoc, paddingStyles, measure }
}

})